export const TagFurnitureType = {
  chair: 'chair',
  kitchenChair: 'highchair',
  toiletWare: 'toilet',
  washWare: 'wash',
  cupboard: 'cupboard',
  cookingWare: 'cook',
  table: 'table',
  bathWare: 'bath',
  shelf: 'shelf',
  sofa: 'sofa',
  bed: 'bed',
  plants: 'plants',
  window: 'window',
  door: 'door',
  stairs: 'stairs',
  light: 'light',
  hanger: 'hanger',
};

export const TagFurnitureUse = {
  storage: 'storage',
  relax: 'relax',
  seat: 'seat',
  sleep: 'sleep',
  wash: 'wash',
  eat: 'eat',
  work: 'work',
};

export const TagRoom = {
  kitchen: 'kitchen',
  livingRoom: 'living room office',
  bedRoom: 'bedroom',
  bathRoom: 'bathroom restroom',
  decor: 'decor any office'
};

export const TagColor = {
  yellow: 'yellow',
  green: 'green',
  cyan: 'cyan',
  blue: 'blue',
  violet: 'violet',
  pink: 'pink',
  red: 'red',
  orange: 'orange',
  white: 'white',
  black: 'black',
  gray: 'gray',
  brown: 'brown'
};

export const TagMaterialFinish = {
  matte: 'matte rough',
  glossy: 'glossy shiny reflective'
};

export const TagMaterialType = {
  floor: 'floor',
  wall: 'wall',
  bricks: 'bricks',
  marble: 'marble',
  plastic: 'plastic',
  wood: 'wood',
  paint: 'paint',
  metal: 'metal',
  glass: 'glass',
  light: 'light bulb',
  water: 'water',
  road: 'road',
  roof: 'roof',
};


